import './post-page.styles';

import initPage from '@/scripts/init/init';
import initBlogLayout from '@/layouts/blog/blog-layout';

import { getTemplateData } from '@/scripts/utils/cms';
import { copyToClipboard } from '@/scripts/utils/base';
import ImgLazyLoad from '@/scripts/lib/ImgLazyLoad';
import GigPopover from '@/components/GigPopover/GigPopover';
import initNewsletters from '@/templates/newsletters/newsletters';

import LikeBtn from './scripts/LikeBtn';
import LikesStorage from './scripts/LikesStorage';

const $page = document.querySelector('.post-page-js');
const $content = $page.querySelector('.post-content-js');

const slug = getTemplateData('slug');
const likes = getTemplateData('likes');

initPage();
initBlogLayout();
new ImgLazyLoad(document.querySelectorAll('img.lazy'));

(function likeBtn() {
   const $likeButtons = [...$page.querySelectorAll('.like-btn-js')];

   const storage = new LikesStorage(slug, { likes });
   $likeButtons.map($ => new LikeBtn($, storage));

   storage.events.addListener('change', (value) => {
      window.humTracker?.track((value) ? 'like' : 'unlike');
   });
}());

(function copyUrl() {
   const buttons = $page.querySelectorAll('.copy-post-url-js');
   const tooltipRoot = $page.querySelector('.url-tooltip-js');
   buttons.forEach(btn => initBtn(btn));

   /** @param {HTMLButtonElement} btn */
   function initBtn(btn) {
      const inSidebar = btn.closest('.side-actions-wrapper-js');
      const $trigger = (inSidebar) ? btn : btn.querySelector('.url-icon-js');
      let hideTimer = 0;

      const popover = new GigPopover(tooltipRoot, $trigger, {
         priority: (inSidebar) ?
            ['right', 'left', 'top', 'bottom'] :
            ['top', 'right', 'bottom', 'left'],
         manageFocus: false,
         openOn: 'none',
         offset: 0,
      });

      btn.addEventListener('click', async () => {
         copyToClipboard(location.href);
         popover.open();
         btn.blur();

         clearTimeout(hideTimer);
         hideTimer = setTimeout(() => popover.close(), 1800);
      });

      if (inSidebar) {
         popover.events.addListener('open.before', () => {
            tooltipRoot.classList.add('url-tooltip__sidebar');
         });

         popover.events.addListener('close.after', () => {
            tooltipRoot.classList.remove('url-tooltip__sidebar');
         });
      }
   }
}());

(function sidebarActions() {
   const $wrapper = $page.querySelector('.side-actions-wrapper-js');
   const $root = $wrapper.querySelector('.side-actions-js');
   const $suggest = $page.querySelector('.side-suggest-js');
   const $tabbable = $root.querySelectorAll('button,a');

   updateVisibility();
   initEvents();

   function initEvents() {
      let frameId = 0;
      document.addEventListener('scroll', () => {
         cancelAnimationFrame(frameId);

         frameId = requestAnimationFrame(() => {
            updateVisibility();
         });
      });
   }

   function updateVisibility() {
      const offsetTop = 1;
      const offsetBottom = window.innerHeight * 0.6;
      const w = $wrapper.getBoundingClientRect();
      const r = $root.getBoundingClientRect();
      const s = $suggest.getBoundingClientRect();

      if (w.height < window.innerHeight * 1.5) {
         return;
      }

      if (r.top <= w.top + offsetTop || r.bottom > w.bottom - offsetBottom) {
         $root.classList.add('post-actions__hidden');
         $tabbable.forEach($ => $.tabIndex = -1);
      } else {
         $root.classList.remove('post-actions__hidden');
         $tabbable.forEach($ => $.removeAttribute('tabIndex'));
      }
      if (s.top <= w.top + offsetTop || s.bottom > w.bottom - offsetBottom) {
         $suggest.classList.add('post-actions__hidden');
         $tabbable.forEach($ => $.tabIndex = -1);
      } else {
         $suggest.classList.remove('post-actions__hidden');
         $tabbable.forEach($ => $.removeAttribute('tabIndex'));
      }
   }
}());

(function iframesAspectRatio() {
   const selector = makeSelector([
      'https://www.youtube.com',
      'https://player.vimeo.com',
   ]);
   const $frames = $content.querySelectorAll(selector);
   $frames.forEach(item => prepareFrame(item));

   /** @param {HTMLIFrameElement} frame */
   function prepareFrame(frame) {
      const $wrapper = createWrapper(frame.height / frame.width);
      frame.replaceWith($wrapper);
      $wrapper.appendChild(frame);
   }

   function createWrapper(ratio) {
      const $wrapper = document.createElement('div');
      $wrapper.classList = 'iframe-wrapper';
      $wrapper.style.setProperty('--ratio', ratio || 9 / 16);
      return $wrapper;
   }

   /** @param  {string[]} urls */
   function makeSelector(urls) {
      return urls.map(url => `iframe[src*="${url}"]`).join(',');
   }
}());

(function newsletters() {
   const parent = $page.querySelector('.newsletters-parent-js');
   initNewsletters(parent);
}());

(function setHumEvents() {
   if (!window.humTracker) return;

   const content = $page.querySelector('.post-content-js');
   const links = [...$page.querySelectorAll('.copy-post-url-js')];
   const fb = [...$page.querySelectorAll('.fb-share-js')];
   const twitter = [...$page.querySelectorAll('.twitter-share-js')];

   humTracker.trackScroll(content, 'post read');
   humTracker.trackClick(links, 'link-share');
   humTracker.trackClick(fb, 'fb-share');
   humTracker.trackClick(twitter, 'twitter-share');
}());